import React, { useEffect } from "react";
import Header from "./components/LandingPage/Header";
import Hero from "./components/LandingPage/Hero";
import Offering from "./components/LandingPage/ApiOfferings";
import Sdk from "./components/LandingPage/Sdk";
import Contact from "./components/LandingPage/Contact";
import BackToTop from "./components/LandingPage/BackToTop";
import Footer from "./components/LandingPage/Footer";
import Code from "./components/LandingPage/CodeSample";
import Cookies from "./components/LandingPage/Cookie";
import "./landing.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useMaterialUIController, setSideBarVisibility } from "context";
import { IsAuthenticated } from "helpers";

export default function HomePage() {
  const [controller, dispatch] = useMaterialUIController();

  useEffect(() => {
    setSideBarVisibility(dispatch, false);
  }, []);

  return (
    <div className="site-wrap">
      <Header />
      <Hero />
      <Offering />
      <Sdk />
      <Code />
      {IsAuthenticated() ? "" : <Contact />}
      <BackToTop />
      <Footer />
      <Cookies />
    </div>
  );
}
